/* gl_multi_select.directive.js */

/* globals angular, $ */
"use strict";
let _ = require("lodash");

module.exports = function ($compile, $timeout) {
    return {
        restrict: "E",
        scope: {
            settings: "=",
            api: "=",
        },

        link: function (scope, element) {
            let childScope = scope.$new();
            let elementLabel;
            let elementSelect;
            let elementView;
            let elementError;
            let templateLabel;
            let templateSelect;
            let templateError;
            let templateView;
            let instanceIconEl;
            let instanceBadgeEl;
            let descriptionIconEl;
            let descriptionContentEl;
            let classInvalid = "gl-invalid";
            let prevValue;
            let openCloseTime;
            let chosenAttrOptions = "";
            let lockedOptions = []; // idx of locked option
            let shrinkGrowTimoutPromise;
            let onUserChangeTimoutPromise;

            templateError = '<p class="gl-error-msg" data-ng-bind="_settings.error"></p>';

            let chosenAttrs = {
                noResultsText: "no-results-text",
                allowSingleDeselect: "allow-single-deselect",
                disableSearchThreshold: "disable-search-threshold",
                disableSearch: "disable-search",
                enableSplitWordSearch: "enable-split-word-search",
                inheritSelectClasses: "inherit-select-classes",
                maxSelectedOptions: "max-selected-options",
                //searchContains: 'search-contains',    // removed use "searchStartsWith": true
                singleBackstrokeDelete: "single-backstroke-delete",
                displayDisabledOptions: "display-disabled-options",
                displaySelectedOptions: "display-selected-options",
                multiple: "multiple",
                width: "width", // set width in containing elmeents style
            };

            // DEFAULT SETTINGS
            scope._settings = {
                addDeleteIcon: false,
                addEditIcon: false,
                disabled: false,
                disableAutoSelect: false,
                editable: true,
                error: undefined,
                hideDropdown: false,
                id: undefined,
                label: undefined,
                name: undefined,
                onChange: undefined,
                onDeleteMenuOption: undefined,
                onUserChange: undefined,
                onValueChange: undefined,
                onEditMenuOption: undefined,
                openDirection: "down",
                options: undefined, // Passed in options
                _options: undefined, // Formatted options
                _selection: undefined, // Selected Option Index
                _optionValues: [],
                placeholder: "&nbsp;", // &nbsp; HACK for image placeholder as chosen puts in its own text if you dont supply a placeholder
                searchStartsWith: false,
                shrinkAndGrow: false,
                instanceMode: false,
                showLabel: false,
                sort: true,
                tabIndex: false,
                title: undefined,
                value: undefined,
                valid: true,
            };

            _.assignWith(scope._settings, scope.settings);

            if (scope.settings.onChange) {
                scope._settings.onChange = function (evt) {
                    scope.settings.onChange(evt, {
                        id: scope._settings.id,
                        name: scope._settings.name,
                        settings: scope.settings,
                    });
                };
            }

            scope.api = angular.extend(scope.api || {}, {
                setLabel: function (label) {
                    scope._settings.label = label;
                },
                getLabel: function () {
                    return scope._settings.label;
                },
                view: function () {
                    setViewMode();
                },
                edit: function () {
                    setEditMode();
                },
                setInvalid: function (msg) {
                    scope._settings.valid = false;
                    if (angular.isString(msg)) {
                        scope._settings.error = msg;
                    } else {
                        scope._settings.error = undefined;
                    }
                    errorMsgCheck();
                },
                setValid: function () {
                    scope._settings.valid = true;
                    errorMsgCheck();
                },
                setValue: function (val) {
                    let selection;
                    let selectedValue;
                    if (scope._settings.multiple) {
                        selection = [];
                        selectedValue = [];
                        let values = _.isArray(val) ? val : [val];
                        _.each(values, function (value /*,key*/) {
                            _.each(scope._settings._optionValues, function (opt, key) {
                                if (_.eq(value, opt)) {
                                    selection.push(key);
                                    selectedValue.push(opt);
                                }
                            });
                        });
                    } else {
                        _.each(scope._settings._optionValues, function (opt, key) {
                            if (_.eq(val, opt)) {
                                selection = key;
                                selectedValue = opt;
                            }
                        });
                    }
                    scope._settings._selection = selection;
                    scope._settings.value = selectedValue;
                    // If shrinkAndGrow has been set, adjust the width
                    if (scope._settings.shrinkAndGrow) {
                        shrinkGrowTimoutPromise = $timeout(function () {
                            setShrinkWidth();
                        });
                    }
                    scope.$applyAsync();
                },
                getValue: function () {
                    return scope._settings.value;
                },
                getOptions: function () {
                    return scope._settings.options; // return original unfiltered options provided
                },
                setOptions: function (options) {
                    scope._settings.options = options; // store the options as they were provided

                    if (_.isEmpty(options)) {
                        options = [];
                    }

                    scope._settings._options = [];
                    scope._settings._optionValues = [];

                    // reformat an array of strings to required label: value: structure
                    options = filterOptions(options);

                    // format the options for the view
                    scope._settings._options = formatOptions(options);
                    if (scope._settings.sort) {
                        scope._settings._options = sortOptions(scope._settings._options);
                    }
                    autoSelect();
                    scope.$applyAsync();
                },
                disable: function () {
                    scope._settings.disabled = true;
                    elementSelect.attr("disabled", true).trigger("chosen:updated");
                },
                enable: function () {
                    scope._settings.disabled = false;
                    elementSelect.removeAttr("disabled").trigger("chosen:updated");
                },
                showOptions: function () {
                    if (scope._settings._options.length > 0) {
                        // because chosen disables select when set with an empty array, but does not enable it when options are set again.
                        scope.api.enable();
                    }
                    elementSelect.trigger("chosen:open");
                },
                hideOptions: function () {
                    element.find("select").trigger("chosen:close");
                },
                addIconClass: function (className) {
                    instanceIconEl.addClass(className);
                },
                removeIconClass: function (className) {
                    instanceIconEl.removeClass(className);
                },
                addBadgeClass: function (className) {
                    instanceBadgeEl.addClass(className);
                },
                removeBadgeClass: function (className) {
                    instanceBadgeEl.removeClass(className);
                },
                resetBadgeClasses: function () {
                    instanceBadgeEl.removeClass();
                    instanceBadgeEl.addClass("badge-icon icon");
                },
                setBadgeTitle: function (newTitle) {
                    instanceBadgeEl[0].title = newTitle;
                },
                resetIconClasses: function () {
                    instanceIconEl.removeClass();
                    instanceIconEl.addClass("instance-icon icon");
                },
                setDescriptionText: function (text) {
                    if (text) {
                        descriptionContentEl[0].textContent = text;
                        if (descriptionIconEl.hasClass("disabled")) {
                            descriptionIconEl.removeClass("disabled");
                            descriptionIconEl.on("click", function (/*evt*/) {
                                if (!descriptionContentEl.hasClass("show")) {
                                    descriptionContentEl.addClass("show");
                                } else {
                                    scope.api.hideDescription();
                                }
                            });
                        }
                    } else {
                        scope.api.hideDescription();
                        descriptionIconEl.unbind();
                        descriptionIconEl.addClass("disabled");
                        descriptionContentEl[0].textContent = "";
                    }
                },
                hideDescription: function () {
                    descriptionContentEl.removeClass("show");
                },
            });

            // remove unworthy options
            function filterOptions(options) {
                let filteredOptions = [];
                _.each(options, function (opt /*,key*/) {
                    if (_.isString(opt)) {
                        filteredOptions.push(opt);
                    } else if (_.isString(opt.label)) {
                        filteredOptions.push(opt);
                    } else if (_.isString(opt.name)) {
                        filteredOptions.push(opt);
                    }
                });
                return filteredOptions;
            }

            function formatOptions(options) {
                let formattedOptions = [];
                _.each(options, function (opt, key) {
                    let newOpt = {
                        value: key,
                    };
                    if (_.isString(opt)) {
                        newOpt.label = opt;
                        scope._settings._optionValues[key] = opt;
                    } else if (_.isPlainObject(opt)) {
                        // label or name
                        if (_.isString(opt.label)) {
                            newOpt.label = opt.label;
                        } else if (_.isString(opt.name)) {
                            newOpt.label = opt.name;
                        }
                        // group
                        if (_.isString(opt.group)) {
                            newOpt.group = opt.group;
                        }
                        // value
                        if (!_.isUndefined(opt.value)) {
                            scope._settings._optionValues[key] = opt.value;
                        } else {
                            scope._settings._optionValues[key] = opt;
                        }
                    }
                    // locks
                    if (_.isBoolean(opt.locked) && opt.locked) {
                        newOpt.locked = true;
                        lockedOptions.push(newOpt);
                    }
                    formattedOptions.push(newOpt);
                });
                return formattedOptions;
            }

            function sortOptions(options) {
                return _.sortBy(options, function (opt) {
                    return opt.label.toLowerCase();
                });
            }

            function setEditMode() {
                element.children().remove();
                scope._settings.editable = true;
                templateLabel =
                    '<label class="gl-multi-select-label" data-ng-show="_settings.showLabel" data-ng-bind="_settings.label"></label>';
                templateSelect =
                    '<select data-ng-attr-id="{{_settings.id}}" data-ng-attr-name="{{_settings.name}}" ';
                templateSelect +=
                    ' style="width: 100%;" chosen ' +
                    chosenAttrOptions +
                    ' data-ng-model="_settings._selection" data-ng-options="option.value as option.label group by option.group for option in _settings._options"><option value=""></option></select>';
                elementSelect = angular.element(templateSelect);
                elementLabel = angular.element(templateLabel);
                if (scope._settings.disabled) {
                    elementSelect.attr("disabled", true);
                }
                element.append(
                    $compile(elementLabel)(childScope),
                    $compile(elementSelect)(childScope)
                );
                elementSelect.on("chosen:ready", function (evt, chosenObj) {
                    // set title of search container
                    if (_.isString(scope._settings.title)) {
                        chosenObj.chosen.container[0].title = scope._settings.title;
                    }
                    processEmptiness(scope._settings.value);
                    element
                        .find(".chosen-results")
                        .attr("data-gl-super-scroll", "data-gl-super-scroll");
                    // Add a hidden class to chosen if the dropdown should be hidden
                    if (scope._settings.hideDropdown === true) {
                        element.find(".chosen-container").addClass("dropdown-hidden");
                    }
                    errorMsgCheck();
                    // If the edit or delete icons should be displayed, build them and their handler logic
                    if (
                        scope._settings.addDeleteIcon === true ||
                        scope._settings.addEditIcon === true
                    ) {
                        // On click of the chosen container, enhance the dropdown items
                        element.find(".chosen-container").click(function () {
                            // Add delete icons to the Chosen dropdown items
                            $timeout(function () {
                                enhanceChosenDropdownItems();
                            });
                        });
                    }
                    // If the shrinkAndGrow setting is in place, add the classes during the appropriate event phases
                    if (scope._settings.shrinkAndGrow) {
                        // Apply the class
                        element.addClass("shrink-and-grow");
                        // Resize container to the width of the selection. Delay is necessary for the outerWidth
                        // to be accurate after initial screen load
                        $timeout(function () {
                            setShrinkWidth();
                        }, 10);
                        // On click of the chosen container, resize back to the full width of the container
                        element.find(".chosen-container").click(function () {
                            setGrowWidth();
                        });
                        // When the dropdown is being hidden, add the 'collapse' class
                        elementSelect.on("chosen:hiding_dropdown", function () {
                            // Add the 'collapse' class to trigger the closing animation of the dropdown
                            element.addClass("collapse");
                            // Remove the the 'collapse' class to allow the dropdown to hide to the left,
                            // and resize the container
                            $timeout(function () {
                                element.removeClass("collapse");
                                setShrinkWidth();
                            }, 300);
                        });
                    }

                    switch (scope._settings.openDirection) {
                        case "down":
                            element.addClass("open-direction-down");
                            break;
                        case "up":
                            element.addClass("open-direction-up");
                            break;
                        case "auto":
                            element.addClass("open-direction-auto");
                            break;
                        default:
                            element.addClass("open-direction-down");
                    }

                    //If instanceMode is enabled, add the dom elements for the construct icon and description "tooltip"
                    if (scope._settings.instanceMode) {
                        instanceIconEl = angular.element("<div class='instance-icon icon'></div>");
                        instanceBadgeEl = angular.element("<div class='badge-icon icon'></div>");
                        descriptionIconEl = angular.element(
                            "<div class='desc-icon icon info disabled'></div>"
                        );
                        descriptionContentEl = angular.element("<div class='desc-content'></div>");

                        element.append(instanceIconEl);
                        element.append(instanceBadgeEl);
                        element.append(descriptionIconEl);
                        element.append(descriptionContentEl);
                    }

                    if (scope._settings.lockable) {
                        scope.$watch(
                            function () {
                                let count = element.find(
                                    "a.search-choice-close, ul.chosen-results li"
                                ).length;
                                return count;
                            },
                            function (/*n, o*/) {
                                manageLocks(chosenObj);
                            }
                        );
                        // drop down rerenders the list so we need this as well
                        elementSelect.on("chosen:showing_dropdown", function () {
                            manageLocks(chosenObj);
                        });
                        elementSelect.on("change", function () {
                            manageLocks(chosenObj);
                        });
                    }
                });

                function manageLocks(chosenObj) {
                    _.each(lockedOptions, function (opt) {
                        let chosenOpt = _.filter(chosenObj.chosen.results_data, {text: opt.label});
                        // Add a disabled class to the search choice list item
                        _.each(element.find("li.search-choice"), function (choice) {
                            if (angular.element(choice).find("span").text() === chosenOpt[0].text) {
                                angular.element(choice).addClass("disabled");
                            }
                        });
                        // Remove the close action
                        element
                            .find(
                                "a.search-choice-close[data-option-array-index=" +
                                    chosenOpt[0].array_index +
                                    "]"
                            )
                            .remove();
                        // Add disabled classes to the selections in the multiselect dropdown
                        element
                            .find(
                                "ul.chosen-results li[data-option-array-index=" +
                                    chosenOpt[0].array_index +
                                    "]"
                            )
                            .removeClass("active-result")
                            .addClass("disabled-result");
                    });
                }

                //////////////////////////////////////////////////
                // Begin chosen hack!
                // Case 14697
                // clicking on a options list with one already open, or
                // if its close to the bottom, it must blur when the browser
                // sets focus to it, and causes chosen to close it on the user.
                //////////////////////////////////////////////////
                elementSelect.on("chosen:showing_dropdown", function (/*evt*/) {
                    openCloseTime = Date.now();
                });
                elementSelect.on("chosen:hiding_dropdown", function (/*evt*/) {
                    let timeDiff = Date.now() - openCloseTime;
                    if (timeDiff < 333) {
                        console.warn(
                            timeDiff +
                                " Warning Multi Select hiding options to quickly after displaying them."
                        );
                        _.defer(function () {
                            elementSelect.focus();
                            elementSelect.trigger("chosen:open");
                        });
                    }
                });
                //////////////////////////////////////////////////
                // End chosen hack
                //////////////////////////////////////////////////

                if (angular.isFunction(scope._settings.onChange)) {
                    elementSelect.on("change", function (evt) {
                        scope._settings.onChange(evt);
                    });
                }
                if (angular.isFunction(scope._settings.onUserChange)) {
                    let len = scope._settings.shrinkAndGrow ? 666 : 0;
                    elementSelect.on("change", function (/*evt*/) {
                        onUserChangeTimoutPromise = $timeout(function () {
                            // let angular set the value before we request it.
                            scope._settings.onUserChange(scope._settings.value, prevValue);
                        }, len);
                    });
                }
                autoSelect();
            }

            function setViewMode() {
                element.children().remove();
                scope._settings.editable = false;
                templateView =
                    '<label class="gl-multi-select-label" data-ng-bind="_settings.label"></label>' +
                    '<p class="gl-multi-select-value" data-ng-bind="_settings.value"></p>';
                elementView = angular.element(templateView);
                element.append($compile(elementView)(childScope));
            }

            function buildDropDownCrudIcons() {
                element.find(".chosen-results .active-result").each(function (index, el) {
                    // Build delete icons
                    if (scope._settings.addDeleteIcon === true) {
                        $(el).append('<a class="delete-button"></a>');
                    }
                    // Build edit icons
                    if (scope._settings.addEditIcon === true) {
                        $(el).append('<a class="edit-button"></a>');
                    }
                });
            }

            function enhanceChosenDropdownItems() {
                // Add Icons
                buildDropDownCrudIcons();
                // Add delete handler
                if (scope._settings.addDeleteIcon === true) {
                    // Add a one-time handler to each delete button
                    addDeleteHandlers();
                }
                // Add edit handler
                if (scope._settings.addEditIcon === true) {
                    // Add a one-time handler to each edit button
                    addEditHandlers();
                }
            }

            function setShrinkWidth() {
                // Apply the outerWidth of the anchor tag to the max-width property of the chosen-container as long
                // as there is a width value
                let newWidth = element.find(".chosen-single").outerWidth(false);
                if (newWidth !== 0) {
                    element.css("max-width", newWidth);
                }
            }

            function setGrowWidth() {
                element.css("max-width", "100%");
            }

            function processEmptiness(value) {
                let c = element.children(".chosen-container");
                if (!_.isEmpty(value)) {
                    c.removeClass("gl-empty");
                } else {
                    c.addClass("gl-empty");
                }
            }

            /*function formatStringOptions(options){
                let formattedOptions = [];
                _.each(options,function(option/!*,key*!/){
                    formattedOptions.push({label:option,value:option});
                });
                return formattedOptions;
            }*/

            function autoSelect() {
                let selectedValue;
                if (!_.isUndefined(scope._settings.value) && !_.isEmpty(scope._settings.value)) {
                    if (_.isBoolean(scope.settings.multiple) && scope.settings.multiple) {
                        selectedValue = [];
                        for (let i = 0; i < scope._settings._optionValues.length; i++) {
                            let val = scope._settings._optionValues[i];
                            for (let j = 0; j < scope._settings.value.length; j++) {
                                let v = scope._settings.value[j];
                                if (_.eq(v, val)) {
                                    selectedValue.push(val);
                                }
                            }
                        }
                    } else {
                        for (let i = 0; i < scope._settings._optionValues.length; i++) {
                            let val = scope._settings._optionValues[i];
                            if (_.eq(scope._settings.value, val)) {
                                selectedValue = val;
                                break;
                            }
                        }
                    }
                }
                // if not set by previous selected value set first indx value
                if (
                    (_.isUndefined(selectedValue) || _.isEmpty(selectedValue)) &&
                    !scope._settings.disableAutoSelect
                ) {
                    // Make sure there are options
                    if (
                        !_.isUndefined(scope._settings._options) &&
                        scope._settings._options.length > 0
                    ) {
                        // Multiple
                        if (_.isBoolean(scope.settings.multiple) && scope.settings.multiple) {
                            selectedValue = [scope._settings._optionValues[0]];
                        } else {
                            selectedValue = scope._settings._optionValues[0];
                        }
                    }
                }

                scope.api.setValue(selectedValue);
            }

            function errorMsgCheck() {
                if (!angular.isUndefined(elementError)) {
                    elementError.remove();
                }
                if (scope._settings.editable) {
                    if (scope._settings.valid) {
                        elementSelect.removeClass(classInvalid);
                        element.find(".chosen-container").removeClass(classInvalid);
                    } else {
                        elementSelect.addClass(classInvalid);
                        element.find(".chosen-container").addClass(classInvalid);
                        if (angular.isString(scope._settings.error)) {
                            elementError = $compile(angular.element(templateError))(scope);
                            element.append(elementError);
                        }
                    }
                }
            }

            /********** START - EVENT HANDLERS **********/
            function addDeleteHandlers() {
                // Add a one-time handler to each delete button
                element.find(".delete-button").one("mouseup", function (event) {
                    // Kill the default behavior and bubbling
                    event.preventDefault();
                    event.stopPropagation();
                    // Capture the key of the option being deleted
                    let tempKey = $(event.target).parent().text();
                    // Loop through the options and remove the selected menu option
                    for (let i = 0; i < scope._settings._options.length; i++) {
                        if (scope._settings._options[i].label === tempKey) {
                            // If the user specified a handler, pass back the menu option being deleted
                            if (scope._settings.onDeleteMenuOption) {
                                scope._settings.onDeleteMenuOption(scope._settings._options[i]);
                            }
                            scope._settings._options.splice(i, 1);
                            break;
                        }
                    }
                    // Allow a timeout for Angular to rebuild the select options, then update chosen
                    $timeout(function () {
                        elementSelect.trigger("chosen:updated");
                        // Serialize JS execution for 2 cycles to allow chosen to update, then put the
                        // icons back in place
                        window.setTimeout(function () {
                            window.setTimeout(function () {
                                enhanceChosenDropdownItems();
                            }, 0);
                        }, 0);
                    });
                    // Fallback for older browsers
                    return false;
                });
            }

            function addEditHandlers() {
                // Add a one-time handler to each edit button
                element.find(".edit-button").one("mouseup", function (event) {
                    // Capture the key of the option being deleted
                    let tempKey = $(event.target).parent().text();
                    for (let i = 0; i < scope._settings._options.length; i++) {
                        if (scope._settings._options[i].label === tempKey) {
                            // If the user specified a handler, pass back the menu option being edited
                            if (scope._settings.onEditMenuOption) {
                                scope._settings.onEditMenuOption(scope._settings._options[i]);
                            }
                            break;
                        }
                    }
                });
            }

            scope.$watch("_settings._selection", function (n /*,o*/) {
                if (_.isArray(n)) {
                    // multiselect
                    let selectedOptions = [];
                    _.each(n, function (optIdx /*,key*/) {
                        selectedOptions.push(scope._settings._optionValues[optIdx]);
                    });
                    scope._settings.value = selectedOptions;
                } else {
                    scope._settings.value = scope._settings._optionValues[n];
                }
            });

            scope.$watch("_settings.value", function (n, o) {
                prevValue = o;
                if (!_.isUndefined(n) && _.isFunction(scope._settings.onValueChange)) {
                    scope._settings.onValueChange(scope._settings.value, prevValue);
                }
            });

            element.on("$destroy", function () {
                element.unbind();
                $timeout.cancel(shrinkGrowTimoutPromise);
                $timeout.cancel(onUserChangeTimoutPromise);
            });

            scope.$on("$destroy", function () {
                element.unbind();
                $timeout.cancel(shrinkGrowTimoutPromise);
                $timeout.cancel(onUserChangeTimoutPromise);
            });
            /********** END - EVENT HANDLERS **********/

            /********** START - INIT **********/
            // Multiple optoins
            if (_.isBoolean(scope.settings.multiple)) {
                if (scope.settings.multiple) {
                    scope._settings._selection = [];
                } else {
                    delete scope.settings.multiple;
                }
            }

            angular.forEach(chosenAttrs, function (attr, key) {
                if (!angular.isUndefined(scope.settings[key])) {
                    chosenAttrOptions += attr + '="_settings.' + key + '" ';
                }
            });

            chosenAttrOptions += 'data-placeholder="' + scope._settings.placeholder + '" ';

            if (!scope._settings.searchStartsWith) {
                chosenAttrOptions += 'search-contains="true" ';
            }

            if (_.isEmpty(scope._settings.options)) {
                scope._settings.options = undefined; // if we don't do this, chosen disables the field and changes the placeholder to "No results match"
            } else {
                scope.api.setOptions(scope._settings.options);
            }

            if (!angular.isUndefined(scope.settings.view) && scope.settings.view === true) {
                setViewMode();
            } else {
                setEditMode();
            }
            /********** END - INIT **********/
        },
    };
};

/*Generated Injectables*/
module.exports.$inject=['$compile','$timeout'];